module.exports = __webpack_public_path__ + "static/media/photo.1f6f1b8e.png";